/**
 * Entrypoint som monterar appen i DOM:en.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Säkerställ att 100vh i webview motsvarar synlig höjd på mobila enheter
if (typeof window !== 'undefined' && !window.__geoquestViewportSetup) {
  const updateViewportUnit = () => {
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    const unit = height / 100;
    document.documentElement.style.setProperty('--app-viewport-vh', `${unit}px`);
    document.documentElement.style.setProperty('--app-viewport-100', `${height}px`);
  };

  const registerViewportListeners = () => {
    updateViewportUnit();
    window.addEventListener('resize', updateViewportUnit);
    window.addEventListener('orientationchange', updateViewportUnit);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportUnit);
    }
  };

  registerViewportListeners();
  window.__geoquestViewportSetup = true;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
